import { useState, useEffect } from 'react';
import { Dimensions } from 'react-native';

const useWidth = () => {
  const [width, setWidth] = useState(() => {
    return Dimensions.get('window').width;
  });

  useEffect(() => {
    const handleDimensionChange = ({ window }) => {
      setWidth(window.width);
    };

    const subscription = Dimensions.addEventListener('change', handleDimensionChange);

    return () => {
      if (subscription && subscription.remove) {
        subscription.remove();
      }
    };
  }, []);

  return width;
};

export default useWidth;
